import { Injectable } from "@angular/core";
import { CenterDto } from "src/app/data/http/dto/user/center-dto.model";
import { StationDto } from "src/app/data/http/dto/user/station-dto.model";
import { UserDto } from "src/app/data/http/dto/user/user-dto.model";
import { Center } from "../models/center.model";
import { Station } from "../models/station.model";
import { User } from "../models/user.model";

@Injectable({
  providedIn: 'root',
})
export class UserMapperService {

  userDtoToUser(userDto: UserDto, token: string): User {

    return new User(
      userDto.email,
      userDto.name,
      userDto.last_name,
      userDto.is_marketing_allowed,
      userDto.is_demo,
      userDto.accepted_terms_version,
      userDto.accepted_privacy_policy_version,
      this.centerDtoToCenter(userDto.center),
      token,
      Boolean(userDto.is_staff),
      (userDto.pending_legal_acceptances || []).map(item => ({
        documentType: item.document_type,
        version: item.version,
      })),
      Boolean(userDto.center_admin),
    )
  }

  userToUserDto(user: User): UserDto {
    return {
      email: user.email,
      name: user.name,
      last_name: user.lastName,
      is_marketing_allowed: user.isMarketingAllowed,
      is_demo: user.isDemo,
      is_staff: user.isStaff,
      center_admin: user.centerAdmin,
      accepted_terms_version: user.acceptedTermsVersion,
      accepted_privacy_policy_version: user.acceptedPrivacyPolicyVersion,
      pending_legal_acceptances: user.pendingLegalAcceptances.map(item => ({
        document_type: item.documentType,
        version: item.version,
      })),
      center: this.centerToCenterDto(user.center),
      password: ''
    };
  }

  centerToCenterDto(center: Center): CenterDto {
    return {
      id: center.id,
      address_1: center.address1,
      address_2: center.address2,
      postal_code: center.postalCode,
      country_iso: center.countryIso,
      name: center.name,
      web: center.web,
      facebook: center.facebook,
      vat: center.vat,
      slogan: center.slogan,
      image: center.image
    };
  }

  centerDtoToCenter(centerDto: CenterDto): Center {
    var image
    if (centerDto.image) {
      image = centerDto.image
    } else {
      image = "./assets/media/Placeholder_Ticket.png"
    }

    return new Center(
      centerDto.id,
      centerDto.address_1,
      centerDto.address_2 || '',
      centerDto.postal_code,
      centerDto.country_iso,
      centerDto.name,
      centerDto.web,
      centerDto.facebook,
      centerDto.vat,
      centerDto.slogan,
      image
    )
  }

  stationDtoToStation(stationDto: StationDto): Station {
    return new Station(
      stationDto.id,
      stationDto.name,
      stationDto.device_id,
      stationDto.device_kind,
      stationDto.enrolled_at,
      stationDto.last_seen_at
    )
  }
}
